import { useParams,useNavigate } from "react-router-dom";
import AxiosInstance from '../AxiosInstance';
import { ArrowLeftCircle } from "react-bootstrap-icons";
import { Button } from "react-bootstrap";
import React, { useState, useEffect,useRef } from "react";
import { PencilFill, TrashFill } from "react-bootstrap-icons";
import Select from "react-select";
import Layout from './Layout';
import ToastNotification from "../ToastNotification";

const ProjectDetails = () => {
    const navigate = useNavigate();
    const { projectId } = useParams();
    const [project, setProject] = useState(null);
    const [newProjectName, setNewProjectName] = useState(""); 
    const [editing, setEditing] = useState(false); 
    const [employees, setEmployees] = useState([]); 
    const [assignedEmployees, setAssignedEmployees] = useState([]);
    const [showAddEmployee, setShowAddEmployee] = useState(false);
    const toastRef = useRef(null);
  useEffect(() => {
    const fetchProjectDetails = async () => {
      try {
        const response = await AxiosInstance.get(`/admin/projectDetails/${projectId}`);
        setProject(response.data);
        setNewProjectName(response.data.project_name);
      } catch (error) {
        toastRef.current?.showToast("Error fetching project details:", "danger");
      }
    };

    fetchProjectDetails();
  }, [projectId]);

 useEffect(() => {
  const capitalize = (str) =>
    str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : "";

  const fetchAllEmployees = async () => {
    try {
      const response = await AxiosInstance.get("/admin/all-employees");
      const employeesData = Array.isArray(response.data)
        ? response.data
        : Array.isArray(response.data.employees)
        ? response.data.employees
        : [];

      // 👇 Get the user_ids of already assigned employees
      const assignedIds = project?.assigned_employees?.map((emp) => emp.user_id) || [];

      // 👇 Filter out already assigned employees
      const filteredEmployees = employeesData.filter(
        (emp) => !assignedIds.includes(emp.user_id)
      );

      // 👇 Create dropdown options
      const options = filteredEmployees.map((emp) => ({
        value: emp.user_id,
        label: [emp.first_name, emp.middle_name, emp.last_name]
          .filter(Boolean)
          .map(capitalize)
          .join(" "),
      }));

      setEmployees(options);
    } catch (error) {
      toastRef.current?.showToast("Error fetching employees", "danger");
    }
  };
  fetchAllEmployees();
  }, [project]); 


  const handleUpdateProjectName = async () => {
    try {
      await AxiosInstance.put("/admin/updateProjectName", {
        project_id: project.project_id,
        new_project_name: newProjectName,
      });
      setProject({ ...project, project_name: newProjectName });
      setEditing(false);
    } catch (error) {
       toastRef.current?.showToast("Error updating project name:", "danger");
    }
  };

  // Function to remove employee from the project
  const handleRemoveEmployee = async (employee_id) => {
    try {
      await AxiosInstance.delete("/admin/removeEmployeeFromProject", {
        data: {
          project_id: project.project_id,
          employee_id: employee_id,
        },
      });

      // Update the UI after employee is removed
      setProject({
        ...project,
        assigned_employees: project.assigned_employees.filter(
          (employee) => employee.user_id !== employee_id
        ),
      });
    } catch (error) {
       toastRef.current?.showToast("Error removing employee:", "danger");
    }
  };


 const handleAddEmployees = async () => {
  try {
    const employee_ids = assignedEmployees.map((emp) => emp.value);

    await AxiosInstance.post("/admin/addEmployeesToProject", {
      project_id: project.project_id,
      employee_ids,
    });

    toastRef.current?.showToast("Employees added successfully", "success");

    const response = await AxiosInstance.get(`/admin/projectDetails/${project.project_id}`);
    setProject(response.data);

    // Reset fields
    setAssignedEmployees([]);
    setShowAddEmployee(false);
  } catch (error) {
    toastRef.current?.showToast("Error adding employees", "danger");
  }
  };

  const formatDate = (date) => {
    const d = new Date(date);
    return `${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}-${d.getFullYear()}`;
  };
  

  if (!project) {
    return (
      <Layout>
        <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
          <p>Loading project details...</p>
        </div>
      </Layout>
    );
  }
  
  return (
    <Layout heading="Project Details">
     <div className="container">
        <div className="row">
          <div className="col-12">
            <Button className="btn btn-secondary mb-3" onClick={() => navigate(-1)}>
              <ArrowLeftCircle />
            </Button>
          </div>
        </div>

        <div className="row">
          <div className="col-12 col-md-10 col-lg-8 mx-auto">
            <div className="card p-4 shadow-sm">
              <div className="mb-2">
                <strong>Project ID:</strong> {project.project_id || "N/A"}
              </div>
              <div className="mb-2">
                <strong>Account:</strong> {project.account_value || "N/A"}
              </div>
              <div className="mb-2">
               <strong>Start Date:</strong>{" "}
                {project.start_date
                  ? formatDate(new Date(project.start_date))
                  : "N/A"}
              </div>
              <div className="mb-2">
               <strong>End Date:</strong>{" "}
                {project.end_date
                  ? formatDate(new Date(project.end_date))
                  : "N/A"}
              </div>

              <div className="mb-2">
                <strong>Project Name:</strong>
                {editing ? (
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control"
                      value={newProjectName}
                      onChange={(e) => setNewProjectName(e.target.value)}
                    />
                    <button className="btn btn-primary" onClick={handleUpdateProjectName}>
                      Save
                    </button>
                  </div>
                ) : (
                  <div className="d-flex align-items-center">
                    {project.project_name || "N/A"}
                    <PencilFill
                      className="ms-2 text-primary"
                      style={{ cursor: "pointer" }}
                      onClick={() => setEditing(true)}
                    />
                  </div>
                )}
              </div>

              {/* Assigned Employees Section */}
              <h3 className="mb-2">Assigned Employees</h3>
              <ul className="list-group">
                {project.assigned_employees.length > 0 ? (
                  project.assigned_employees.map((employee) => (
                    <li
                      key={employee.user_id}
                      className="list-group-item d-flex justify-content-between align-items-center"
                    >
                      {employee.username}
                      <button
                        className="btn btn-danger btn-sm"
                        onClick={() => handleRemoveEmployee(employee.user_id)}
                      >
                        <TrashFill />
                      </button>
                    </li>
                  ))
                ) : (
                  <li className="list-group-item">No employees assigned.</li>
                )}
              </ul>

              <div className="mt-4">
                <button className="btn btn-sm btn-primary" onClick={() => setShowAddEmployee(!showAddEmployee)}>
                  Add New Employee
                </button>
              </div>

              {showAddEmployee && (
                <div className="mt-3">
                  <label className="form-label">Assign Employees:</label>
                  <Select
                    isMulti
                    options={employees}
                    value={assignedEmployees}
                    onChange={(selectedOptions) => setAssignedEmployees(selectedOptions || [])}
                    placeholder="Select employees"
                    className="react-select-container"
                    classNamePrefix="react-select"
                  />
                  <button className="btn btn-primary mt-3" onClick={handleAddEmployees}>
                    Add
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
        <ToastNotification ref={toastRef} />
      </div>
     </Layout>
  );  
};

export default ProjectDetails;
